{
    "raporkampanya": {
        "Baslik": "Campaign Report",
        "Kampanya": "Campaign",
        "Kullanici": "User / Team",
        "Detay": "Detail",
        "Urun": "Product",
        "HedefAdet": "Target Quantity",
        "HedefTutar": "Target Amount",
        "OnayliAdet": "Approved Quantity",
        "OnayliTutar": "Approved Amount",
        "OnayliApe": "Approved APE",
        "IptalAdet": "Cancelled Quantity",
        "IptalTutar": "Cancelled Amount",
        "IptalApe": "Cancelled APE",
        "CaymaAdet": "Withdrawal Quantity",
        "Ara": "Search",
        "Temizle": "Clear",
        "Hedefler": "Targets",
        "Toplam": "Total",
        "Adet": "Count",
        "Satislar": "Sales"
    }
}
